<h2 class="heading-4">Your {{ vm.claimType }}</h2>

<p class="body mt-8">To book your repair under the {{ vm.manufacturer }} guarantee, please call:</p>

<app-telephone-link
  class="mt-8"
  postCodeMessagingClasses="max-w-480"
  [phoneNumber]="vm.phoneNumber"
  [largeFont]="true"
  [postCode]="vm.postCode"
/>
